import { Grid } from "@material-ui/core";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";
import { Margin } from "../../../../theme/styles/Utils";
import Chip from "../../../../components/basics/Chip";
import { HeaderCard } from "../styles/Produto";

export default function CardProdutoLocalizacao({ valuesSetters = {} }) {
  const {
    hallModal,
    setHallModal,
    hallwayModal,
    setHallwayModal,
    shelfModal,
    setShelfModal,
    boxModal,
    setBoxModal,
  } = valuesSetters;
  return (
    <Grid item xs={12}>
      <Card line="left" lineColor="primary">
        <HeaderCard>
          <Grid container>
            <Chip label="LOCALIZAÇÃO" bgcolor="secondary" />
          </Grid>
        </HeaderCard>

        <Margin top="10" bottom="10">
          <Grid item xs={12} container spacing={2}>
            <Grid item md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Salão"
                maxLength={50}
                value={hallModal}
                setValue={setHallModal}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Corredor"
                maxLength={60}
                value={hallwayModal}
                setValue={setHallwayModal}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Prateleira"
                maxLength={50}
                value={shelfModal}
                setValue={setShelfModal}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Box"
                maxLength={50}
                value={boxModal}
                setValue={setBoxModal}
              />
            </Grid>
          </Grid>
        </Margin>
      </Card>
    </Grid>
  );
}
